import useApiQuery from 'shared/hooks/use-api-query';
import {BillingProps} from '../types';
import billingsKeys from '../util/billings-keys';

const useBilling = (billingId: string) => {
  return useApiQuery<BillingProps>({
    url: `/billing/${billingId}`,
    queryKey: billingsKeys.details(billingId),
  });
};

export default useBilling;
